import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Typography, Box, MenuItem, Divider } from "@mui/material";
import { GAUGE_FIELDS } from "./jdrConstants";

const DRACONIQUE_INIT_FIELDS = [
  { field: "ManaAirDraconiqueMax",     label: "Air ☽ Max",    currentField: "CurrentManaAirDraconique",   currentLabel: "Air ☽ Actuel",    color: "#94a3b8" },
  { field: "ManaEauDraconiqueMax",     label: "Eau ☽ Max",    currentField: "CurrentManaEauDraconique",   currentLabel: "Eau ☽ Actuel",    color: "#c084fc" },
  { field: "ManaTerreDraconiqueMax",   label: "Terre ☽ Max",  currentField: "CurrentManaTerreDraconique", currentLabel: "Terre ☽ Actuel",  color: "#d97706" },
  { field: "ManaFeuDraconiqueMax",     label: "Feu ☽ Max",    currentField: "CurrentManaFeuDraconique",   currentLabel: "Feu ☽ Actuel",   color: "#f87171" },
];

const CELESTE_FIELDS = [
  { field: "CelesteManaAir",     label: "Mana Air",     color: "#14b8a6" },
  { field: "CelesteManaEau",     label: "Mana Eau",     color: "#60a5fa" },
  { field: "CelesteManaTerre",   label: "Mana Terre",   color: "#fb923c" },
  { field: "CelesteManafeu",     label: "Mana Feu",     color: "#fb7185" },
  { field: "CelesteManaVolonte", label: "Mana Volonté", color: "#a855f7" },
  { field: "CelesteManaVital",   label: "Mana Vital",   color: "#f87171" },
];

export default function MjScenarioEndDialog({
  open, onClose,
  characters, selected,
  successLog, gaugesByCharId, scenarioSnapshot,
  rewardsByCharId,
  statOptions,
  buildFieldLabel,
  ensureRewardRows, addRewardRow, removeRewardRow, updateRewardRow,
  draconiqueInitByCharId, updateDraconiqueInit,
  draconiqueByCharId,
  celesteByCharId, celesteInputByCharId, updateCelesteInput,
  onConfirm,
}) {
  const hasDraconiqueSection = (rows) =>
    rows.some(r => r.field === "HasDraconiqueHeart");

  const isDraconiqueNew = (charId) => !draconiqueByCharId?.[charId];

  const hasCelesteUnlock = (charId, rows, char) =>
    rows.some(r => r.field === "HasCeleste" && Number(r.delta) > 0)
    && Number(char.HasCeleste) !== 1;

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>Fin de scénario</DialogTitle>

      <DialogContent sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <Typography variant="body2" sx={{ opacity: 0.8 }}>
          Les joueurs concernés = ta sélection actuelle. Ajoute les gains, puis valide.
          Les jauges seront remises au max (après augmentation éventuelle des max).
        </Typography>

        {characters
          .filter((c) => selected.has(c.ID_character))
          .map((char) => {
            const charId = char.ID_character;
            const rows   = rewardsByCharId[charId] || [];

            return (
              <div key={charId} style={{ border: "1px solid rgba(255,255,255,0.2)", borderRadius: 10, padding: 12 }}>
                <Typography variant="h6">{char.Name_character}</Typography>

                {/* Résumé des réussites */}
                {(() => {
                  const log = successLog[charId] || {};
                  const entries = Object.entries(log);
                  if (entries.length === 0) return null;
                  return (
                    <Box sx={{ mt: 1, mb: 0.5, p: 1, background: "rgba(255,255,255,0.04)", borderRadius: 1 }}>
                      <Typography variant="caption" sx={{ color: "rgba(255,255,255,0.45)", display: "block", mb: 0.5, fontWeight: "bold" }}>
                        Réussites pendant le scénario :
                      </Typography>
                      {entries.map(([fieldKey, counts]) => {
                        const flagged = counts.r >= 3 || counts.c >= 1;
                        return (
                          <Box key={fieldKey} sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.25 }}>
                            {flagged && <Typography sx={{ fontSize: "0.8rem" }}>⬆</Typography>}
                            <Typography variant="caption" sx={{ flex: 1, color: flagged ? "#ffa726" : "rgba(255,255,255,0.55)" }}>
                              {buildFieldLabel(fieldKey)}
                            </Typography>
                            <Typography variant="caption" sx={{ color: "#90caf9" }}>{counts.r}R</Typography>
                            <Typography variant="caption" sx={{ color: "#fbbf24", ml: 0.5 }}>{counts.c}★</Typography>
                          </Box>
                        );
                      })}
                    </Box>
                  );
                })()}

                {/* Mana consommé */}
                {(() => {
                  const gauges   = gaugesByCharId[charId] || {};
                  const consumed = GAUGE_FIELDS.filter((f) => {
                    const max     = Number(char[f.maxKey]);
                    const current = Number(gauges[f.key] ?? max);
                    return max > 0 && current < max;
                  });
                  if (consumed.length === 0) return null;
                  return (
                    <Box sx={{ mt: 0.5, mb: 0.5, p: 1, background: "rgba(255,255,255,0.04)", borderRadius: 1 }}>
                      <Typography variant="caption" sx={{ color: "rgba(255,255,255,0.45)", display: "block", mb: 0.5, fontWeight: "bold" }}>
                        Mana consommé :
                      </Typography>
                      {consumed.map((f) => {
                        const max     = Number(char[f.maxKey]);
                        const current = Number(gauges[f.key] ?? max);
                        const used    = max - current;
                        return (
                          <Box key={f.key} sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.25 }}>
                            <Box sx={{ width: 8, height: 8, borderRadius: "50%", background: f.color, flexShrink: 0 }} />
                            <Typography variant="caption" sx={{ flex: 1, color: "rgba(255,255,255,0.55)" }}>{f.label}</Typography>
                            <Typography variant="caption" sx={{ color: f.color }}>-{used} pts ({current}/{max})</Typography>
                          </Box>
                        );
                      })}
                    </Box>
                  );
                })()}

                <div style={{ display: "flex", gap: 8, marginTop: 8 }}>
                  <Button size="small" onClick={() => { ensureRewardRows(charId); addRewardRow(charId); }}>
                    + Ajouter une stat
                  </Button>
                </div>

                <div style={{ display: "flex", flexDirection: "column", gap: 10, marginTop: 10 }}>
                  {rows.map((row, idx) => {
                    const snap    = scenarioSnapshot?.[charId];
                    const valAvant = row.field && snap ? snap[row.field] : undefined;
                    const valApres = valAvant !== undefined ? valAvant + (row.delta ?? 0) : undefined;
                    return (
                      <div key={idx} style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap" }}>
                        <TextField
                          select fullWidth label="Stat / Compétence"
                          value={row.field || ""}
                          onChange={(e) => {
                            const isUnlock = e.target.value === "HasDraconiqueHeart" || e.target.value === "HasCeleste";
                            updateRewardRow(charId, idx, { field: e.target.value, ...(isUnlock ? { delta: 1 } : {}) });
                          }}
                          sx={{ minWidth: 180, flex: 1 }}
                        >
                          <MenuItem value="">— Choisir —</MenuItem>
                          {statOptions.map((opt) => (
                            <MenuItem key={opt.field} value={opt.field}>
                              {opt.label}
                              {scenarioSnapshot?.[charId]?.[opt.field] !== undefined && (
                                <span style={{ opacity: 0.55, fontSize: "0.8em", marginLeft: 6 }}>
                                  (avant : {scenarioSnapshot[charId][opt.field]})
                                </span>
                              )}
                            </MenuItem>
                          ))}
                        </TextField>

                        {valAvant !== undefined && (
                          <Typography variant="body2" sx={{ whiteSpace: "nowrap", opacity: 0.7, minWidth: 90 }}>
                            {valAvant} → {valApres}
                          </Typography>
                        )}

                        <TextField
                          label="delta" type="number"
                          value={row.delta ?? 0}
                          onChange={(e) => updateRewardRow(charId, idx, { delta: Number(e.target.value) })}
                          sx={{ width: 100 }}
                        />

                        <Button size="small" color="error"
                          onClick={() => removeRewardRow(charId, idx)}
                          disabled={(rewardsByCharId[charId] || []).length <= 1}
                        >
                          Supprimer
                        </Button>
                      </div>
                    );
                  })}
                </div>

                {/* Initialisation du cœur draconique — apparaît automatiquement si HasDraconiqueHeart = +1 */}
                {hasDraconiqueSection(rows) && (
                  <Box sx={{ mt: 2, p: 1.5, border: "1px solid rgba(148,163,184,0.4)", borderRadius: 2, background: "rgba(148,163,184,0.05)" }}>
                    <Divider sx={{ mb: 1.5 }}>
                      <Typography variant="caption" sx={{ color: "#94a3b8", fontWeight: "bold", letterSpacing: 1 }}>
                        {isDraconiqueNew(charId) ? "🐉 INITIALISATION DU CŒUR DRACONIQUE" : "🐉 MISE À JOUR DU CŒUR DRACONIQUE"}
                      </Typography>
                    </Divider>
                    <Typography variant="caption" sx={{ color: "rgba(255,255,255,0.5)", display: "block", mb: 1.5 }}>
                      {isDraconiqueNew(charId)
                        ? "Renseigne les valeurs de départ. Les champs \"Actuel\" sont optionnels (défaut = Max)."
                        : "Modifie les valeurs max et actuelles du cœur draconique."}
                    </Typography>
                    <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
                      {DRACONIQUE_INIT_FIELDS.map(({ field, label, currentField, currentLabel, color }) => {
                        const init    = draconiqueInitByCharId[charId] || {};
                        const existing = draconiqueByCharId?.[charId];
                        const maxVal  = init[field]       !== undefined ? init[field]       : (existing ? Number(existing[field])       : "");
                        const currVal = init[currentField] !== undefined ? init[currentField] : (existing ? Number(existing[currentField]) : "");
                        return (
                          <Box key={field} sx={{ display: "flex", gap: 1.5, alignItems: "center", flexWrap: "wrap" }}>
                            <Box sx={{ width: 8, height: 8, borderRadius: "50%", background: color, flexShrink: 0 }} />
                            <TextField
                              label={label} type="number" size="small"
                              value={maxVal}
                              onChange={e => updateDraconiqueInit(charId, field, Number(e.target.value))}
                              sx={{ width: 130, "& .MuiInputLabel-root": { color }, "& .MuiOutlinedInput-root": { "& fieldset": { borderColor: `${color}66` } } }}
                              inputProps={{ min: 0 }}
                            />
                            <TextField
                              label={currentLabel} type="number" size="small"
                              value={currVal}
                              onChange={e => updateDraconiqueInit(charId, currentField, Number(e.target.value))}
                              placeholder={`défaut: Max`}
                              sx={{ width: 150, "& .MuiInputLabel-root": { color: `${color}aa` }, "& .MuiOutlinedInput-root": { "& fieldset": { borderColor: `${color}33` } } }}
                              inputProps={{ min: 0 }}
                            />
                          </Box>
                        );
                      })}
                    </Box>
                  </Box>
                )}

                {/* Céleste — init (nouveau déblocage) ou mise à jour (déjà actif) */}
                {(hasCelesteUnlock(charId, rows, char) || Number(char.HasCeleste) === 1) && (
                  <Box sx={{ mt: 2, p: 1.5, border: "1px solid rgba(253,224,71,0.35)", borderRadius: 2, background: "rgba(253,224,71,0.04)" }}>
                    <Divider sx={{ mb: 1.5 }}>
                      <Typography variant="caption" sx={{ color: "#fef08a", fontWeight: "bold", letterSpacing: 1 }}>
                        {hasCelesteUnlock(charId, rows, char) ? "✦ INITIALISATION DU CÉLESTE" : "✦ MISE À JOUR DU CÉLESTE"}
                      </Typography>
                    </Divider>
                    <Typography variant="caption" sx={{ color: "rgba(255,255,255,0.5)", display: "block", mb: 1.5 }}>
                      {hasCelesteUnlock(charId, rows, char)
                        ? "Définis le % de Céleste pour chaque mana concerné (0 = pas de Céleste sur ce mana)."
                        : "Modifie les % de Céleste. Laisse vide pour ne pas modifier un mana."}
                    </Typography>
                    <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
                      {CELESTE_FIELDS.map(({ field, label, color }) => {
                        const existing = celesteByCharId?.[charId] ? Number(celesteByCharId[charId][field]) : undefined;
                        const inputVal = celesteInputByCharId?.[charId]?.[field];
                        return (
                          <Box key={field} sx={{ display: "flex", gap: 1.5, alignItems: "center" }}>
                            <Box sx={{ width: 8, height: 8, borderRadius: "50%", background: color, flexShrink: 0 }} />
                            <Typography variant="caption" sx={{ color, minWidth: 90 }}>{label}</Typography>
                            <TextField
                              label="% Céleste" type="number" size="small"
                              value={inputVal ?? (existing ?? "")}
                              onChange={e => updateCelesteInput(charId, field, e.target.value === "" ? "" : Number(e.target.value))}
                              placeholder={existing !== undefined ? `actuel: ${existing}%` : "0"}
                              sx={{ width: 130, "& .MuiInputLabel-root": { color: "#fef08a88" }, "& .MuiOutlinedInput-root": { "& fieldset": { borderColor: "#fef08a44" } } }}
                              inputProps={{ min: 0, max: 100 }}
                            />
                            {existing !== undefined && inputVal !== undefined && inputVal !== existing && (
                              <Typography variant="caption" sx={{ color: "#fef08a", opacity: 0.7 }}>
                                {existing}% → {inputVal}%
                              </Typography>
                            )}
                          </Box>
                        );
                      })}
                    </Box>
                  </Box>
                )}
              </div>
            );
          })}

        {selected.size === 0 && (
          <Typography sx={{ opacity: 0.8 }}>
            Aucun joueur sélectionné. Coche des joueurs dans le tableau avant.
          </Typography>
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Annuler</Button>
        <Button variant="contained" onClick={onConfirm} disabled={selected.size === 0}>
          Valider fin de scénario
        </Button>
      </DialogActions>
    </Dialog>
  );
}
